/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Model_Downgraded_UnavailableInputs */

const en_model_downgraded_unavailable = /** @type {(inputs: Model_Downgraded_UnavailableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} is busy right now — this used ${i?.to} instead. Your credits were not charged.`)
};

const id_model_downgraded_unavailable = /** @type {(inputs: Model_Downgraded_UnavailableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} sedang penuh — hasil ini memakai ${i?.to}. Kredit kamu tidak dipotong.`)
};

/**
* | output |
* | --- |
* | "{from} is busy right now — this used {to} instead. Your credits were not charged." |
*
* @param {Model_Downgraded_UnavailableInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_downgraded_unavailable = /** @type {((inputs: Model_Downgraded_UnavailableInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Downgraded_UnavailableInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_downgraded_unavailable(inputs)
	return en_model_downgraded_unavailable(inputs)
});